// Normalise an uploaded profile photo to PNG bytes, downscaled so the CV
// stays small and the compile stays fast. Everything is client-side (canvas)
// — the image never leaves the browser, same as the rest of the app.
const MAX_DIM = 512; // px — plenty for a print CV headshot

// Neutral placeholder headshot (grey avatar silhouette) so templates that
// reference image("/profile.png") still compile before the user uploads a
// real photo. Drawn once and cached.
let placeholder: Uint8Array | null = null;
export async function placeholderPng(): Promise<Uint8Array> {
  if (placeholder) return placeholder;
  const s = MAX_DIM;
  const canvas = document.createElement("canvas");
  canvas.width = s;
  canvas.height = s;
  const ctx = canvas.getContext("2d")!;
  ctx.fillStyle = "#e5e3dd";
  ctx.fillRect(0, 0, s, s);
  ctx.fillStyle = "#a3a39e";
  // head
  ctx.beginPath();
  ctx.arc(s / 2, s * 0.4, s * 0.16, 0, Math.PI * 2);
  ctx.fill();
  // shoulders
  ctx.beginPath();
  ctx.arc(s / 2, s * 0.95, s * 0.30, Math.PI, 0);
  ctx.fill();
  const blob = await new Promise<Blob | null>((res) => canvas.toBlob(res, "image/png"));
  placeholder = new Uint8Array(await blob!.arrayBuffer());
  return placeholder;
}

export async function toProfilePng(file: File): Promise<Uint8Array> {
  const bitmap = await createImageBitmap(file);
  try {
    const scale = Math.min(1, MAX_DIM / Math.max(bitmap.width, bitmap.height));
    const w = Math.max(1, Math.round(bitmap.width * scale));
    const h = Math.max(1, Math.round(bitmap.height * scale));
    const canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext("2d");
    if (!ctx) throw new Error("no_canvas_context");
    ctx.drawImage(bitmap, 0, 0, w, h);
    const blob = await new Promise<Blob | null>((res) =>
      canvas.toBlob(res, "image/png"),
    );
    if (!blob) throw new Error("encode_failed");
    return new Uint8Array(await blob.arrayBuffer());
  } finally {
    bitmap.close();
  }
}
